//Weather
import { IServiceListFilterDTO, IStoreState, ITripFilters, IZoneObject, WeatherQueryParams } from '../../types'
import { getCurrentOrganization } from '../../state/reducers/organizations'
import { connect } from 'react-redux'
import Weather from '../../components/navigation/Weather'
import { RouteProps } from 'react-router'
import * as tripActions from '../../state/actions/trips'
import { getAccessJwtPayload } from 'src/utils/auth'
import { getTripMenuServiceList } from 'src/state/reducers/trip-menu-services'
import { setVisible, toggleZone } from 'src/state/actions/goinzones'
//Do not remove this!
export function mapStateToProps(state: IStoreState, ownProps: any) {
  const org = getCurrentOrganization(state)
  const uid = state.user.currentUserId
  const loginData = getAccessJwtPayload()
  const userName = loginData ? loginData.firstName : ''
  const isAdmin = state.authorization.type === ''
  const resourcePermissions = state.teamMemberPermission.currentPermission
    ? state.teamMemberPermission.currentPermission.resourcePermissions
    : {}
  return {
    orgId: state.organizations ? state.organizations.currentOrgId : '',
    orgName: org ? org.name : '',
    orgServiceAreaName: org ? org.serviceAreaName : '',
    userName,
    isAdmin,
    resourcePermissions,
    orgRoles: loginData ? loginData.rolesInOrganizations : [],
    providerRoles: loginData ? loginData.rolesInProviders : [],
    services: getTripMenuServiceList(state.tripMenuService),
    tripFilters: state.trips.filters,
    zones: state.goinzones.items,
    visible: state.goinzones.visible,
    tripsPerService: state.trips.fetchTotalTripsPerService,
    location: ownProps.location,
    weather: state.trips.weather
  }
}
export function mapDispatchToProps(dispatch: any) {
  return {
    fetchTotalTripsPerService: (orgId: string, dto: IServiceListFilterDTO) =>
      dispatch(tripActions.getTotalTripsPerService(orgId, dto)),
    updateTripFilters: (filters: ITripFilters) => {
      return dispatch(tripActions.actionCreators.updateTripFilters(filters))
    },
    toggleZone: (zone: { [key: string]: IZoneObject } | {}) => {
      return dispatch(toggleZone(zone))
    },
    setVisible: (visible: boolean) => {
      return dispatch(setVisible(visible))
    },
    getWeather: (orgId: string, params: WeatherQueryParams) => dispatch(tripActions.getWeatherUpdate(orgId, params))
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Weather)



// WEBPACK FOOTER //
// ./src/containers/navigation/Weather.ts